import * as React from "react"
import { presets } from "./text.presets"
import { TextProps } from "./text.props"
/**
 * For your text displaying needs.
 *
 * This component is a HOC over the built-in React Native one.
 */
function Text(props: TextProps) {
  // grab the props
  const { preset = "default", tx, txOptions, text, children, style: styleOverride, ...rest } = props

  // figure out which content to use
  const content = text || children
  const style = presets[preset] || presets.default
  return (
    <text style={style} {...rest} >
      {content}
    </text>
  )
}

export default Text
